const StartedIcon = ({ size = "12px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 128 128"
      width={size}
      height={size}
    >
      <path
        d="M82.73 60.27s6.99-37.24 8.2-44.46c1.69-10-4.39-13.93-9.6-10.71-4.75 2.93-7.8 12-10.69 22.53-4.83 17.6-3.53 33.74-3.53 33.74z"
        fill="#ffca28"
      />
      <path
        d="m80.05 60.96 20.57 29.83s2.5-26.91-7.74-50.02c-5.45-12.3-10.06-18.86-15.12-24.92C73.12 10.3 70 8.4 65.9 10.69c-2.55 1.43-5.12 5.65-.7 14.28 3.42 6.68 7.53 12.39 9.91 17.88s4.94 18.11 4.94 18.11"
        fill="#ffca28"
      />
      <path
        d="M63.76 123.04c-8.9-.03-21.66-3.01-30.39-19.03-5.35-9.81-7.03-22.13-5.92-33.14.72-7.18 3.07-12.86 7.48-14.95 6.29-2.98 10.93 1 10.93 1S44.24 47 51.8 44.57c9.72-3.12 12.55 7.12 12.55 7.12l3.84 8.17 30.04 1.65s3.17 20.35-.18 33.63c-6.98 27.58-25.39 27.93-34.29 27.9"
        fill="#ffca28"
      />
      <path
        d="M50.87 65.7s-2.46 1.89-2.04 5.28c.84 6.72-4.91 11.98-11.02 8.18-.42 1.97-.6 4.78 3.4 9.92 2.63 3.38 8.17 6.59 12.06 8.38 4.66 2.14 8.07 4.22 9.12 8.37.29-5.93 3.28-11.67 7.97-15.3 1.27-.99 2.67-1.83 3.84-2.93s-2.14-1.57-3.92-1.08c-5.79 1.59-14.22-1.45-16.72-6.9-.6-1.31-1.92-6.48 4.15-7.56 6.94-1.22 10.5-2.06 10.5-2.06l-.81-10.11s-2.56.02-3.01.28c0 0-.34 4.04-5.64 5.81-4.44 1.48-7.88-.28-7.88-.28"
        fill="#ffb300"
      />
      <path
        d="M79.55 60.94s-2 .16-4.73 2.9c-2.73 2.73-2.24 3.99-3.54 4.6-.78.36-1.78.3-2.48-.19-.87-.6-1.03-1.8-1.12-2.85-.89-10.32-1.66-21.03 1.9-30.76 1.18 1.49 10.76 25.39 9.97 26.3"
        fill="#ffb300"
      />
      <path
        d="M69.42 32.69c-.7 2.88-.71 3.41-1.13 6.1 1.59 2.32 7.32 12.04 8.97 18.04.19.69-.09 2.17-.35 3.27-.17.71.41 1.38 1.14 1.31.62-.06 1.35-.19 2-.45.46-.19.71-.69.61-1.18-.11-.55-.28-1.37-.51-2.4-2.86-12.98-8.45-21.69-10.73-24.69"
        fill="#eda600"
      />
      <path
        d="M100.61 90.79s2.5-26.91-7.74-50.02c-1.63-3.68-3.19-6.85-4.71-9.64.39-2.15 2.23-12.22 2.78-15.31.48-2.72.26-4.82.01-6.05-.11-.53-.36-.63-.69-.2-.54.7-1.21 2.56-2.07 5.75-.67 2.48-1.87 9.07-2.34 11.77-2.7-4.46-5.33-7.92-8.09-11.23-1.36-1.63-3.31-3.71-4.54-4.55-.96-.66-1.37-.49-.95.18.41.67 2.42 3.89 3.42 5.61 3.95 6.81 9.24 13.17 14.44 24.9 5.98 13.49 7.46 28.47 7.7 38.18-1.28-2.42-3.42-5.12-4.91-7.06-5.58-7.22-10.53-9.35-16.17-8.39-2.57.44-4.92 1.92-7.87 3.24C68.68 52.03 61.36 47 61.36 47c1.99 5.57 3.7 14.19 3.61 22.24 0 0-2.8.85-5.22.96-2.95.02-5.07 1.07-6.39 2.64-1.37-5.2-3.31-10.99-5.21-13.48-3.22-4.21-6.94-4.31-6.94-4.31 8.34 10.47 9.41 24.82 9.42 24.91l.19.2c.08 1.82-.62 5.61-3.45 6.46-2.16.65-4.98.95-11.58-11.55-.82-1.55-2.02-2.4-2.99-2.83-.59-.26-1.22.3-1.01.91 3.29 9.44 7.94 17.63 13.93 17.65.9 0 1.84-.15 2.84-.47 1.79-.58 4.58-1.64 6.08-5.71 2.3 2.46 5.94 4.24 10.88 4.26l2.9-.05c-2.57 3.09-7.95 10.01-6.92 23.41.66 1.91 2.76-18.63 14.37-23.27.79-.32 2.81 3.99 6.99 4.65.23.04.51-.02.6-.23s-.07-.44-.23-.6c-3.86-3.96-4.9-8.23-6.51-8.64-1.62-.41-2.29.3-5.91.73-16.35 1.94-16.11-7.05-15.32-8.55s2.72-2.22 4.42-2.29c7.95-.34 13.7-4.5 16.6-5.41 5.65-2.38 11.43 4.39 15.61 10.17 1.29 2.01 4.77 7.24 5.08 14.72.17 4.17-1.75 13.34-7.89 19.14-12.29 11.59-26.53 9.48-30.39 9.01s-9.34-1.62-9.34-1.62S56.4 124 67.32 124c11.5 0 20.77-3.84 26.47-11.42 3.98-5.29 6.01-10.22 6.8-19.25.07-.85.07-1.71.02-2.56z"
        fill="#eda600"
      />
    </svg>
  );
};

export default StartedIcon;
